export type DateTimeDTO = string;

export type CoordinateModelDTO = {
  lat: number;
  lng: number;
};

export type SearchCoordinateDTO = [number, number];

export type SearchReferenceDTO = string;

export type SearchReferenceModel = SearchReferenceDTO;

export enum ShipmentVariantModel {
  AirSaved = "air-saved",
  AirSearch = "air-search",
  SeaSaved = "sea-saved",
  SeaSearch = "sea-search",
  RailSearch = "rail-search",
  RoadSearch = "road-search",
  ParcelSearch = "parcel-search",
}

export enum CardDates {
  atd = "atd",
  etd = "etd",
  ata = "ata",
  eta = "eta",
}

export type DateTimeModel = string;

export type CoordinateModel = {
  lat: number;
  lng: number;
};

export const ShipmentType = {
  SEA: "Sea",
  AIR: "Air",
  RAIL: "Rail",
  ROAD: "Road",
  PARCEL: "Parcel",
} as const;

export const ApiShipmentType = {
  SEA: "SEA",
  AIR: "AIR",
} as const;

export type ShipmentTypeKey = keyof typeof ShipmentType;

export type CarrierType = {
  carrierName: string;
  scacCodes: string[];
};

export type StatusProps<T extends string = string> = {
  className?: string;
  style?: React.CSSProperties;
  status?: T | null;
  dataTestId?: string;
};

export type ProgressLineProps = {
  percent: number;
  status: "location-data" | "not-founded";
  rotation: "horizontal" | "vertical";
  className?: string;
};
